import React, { useEffect, useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { List as ListComponent } from 'src/mtska-frontend-app-component';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { useLoadAll } from 'src/mtska-frontend-data-provider/hooks/useLoadAll.hooks';
import { useGridApiRef } from '@mui/x-data-grid';
import JSONPretty from 'react-json-pretty';

const dataProviderName = 'audiences/audiencelead';
const moduleName = 'AudienceLeads';

const ListLead = ({ onTotalChange, filters }) => {
	const { t } = useTranslation();
	const apiRef = useGridApiRef();

	const { loadAll, items, total, loading, reloadCounter } = useDataProvider(dataProviderName);

	const [internalModel, setInternalModel] = useState();
	const [listFilterPageSort, setListFilterPageSort] = useState();

	const handleFilterPageSortChange = (model) => {
		setInternalModel(model);
	};

	const mergedFilterPageSort = useMemo(() => {
		const base = internalModel || {};
		const merged = { ...base };

		const internalItems = base?.filterModel?.items || [];
		const externalItems = (filters?.items || []).filter(
			item => item.field && item.operator && item.value
		);

		const allItems = [...internalItems, ...externalItems];

		if (allItems.length > 0) {
			merged.filterModel = {
				items: allItems,
				logicOperator: 'and'
			};
		} else {
			delete merged.filterModel;
		}

		console.log("Modello DataGrid originale:", base);
		console.log("Filtri esterni ricevuti:", externalItems);
		console.log("Filtro effettivo usato in ListLead:", merged);

		return merged;
	}, [internalModel, filters]);

	useEffect(() => {
		setListFilterPageSort(mergedFilterPageSort);
	}, [mergedFilterPageSort]);

	useLoadAll({ listFilterPageSort, loadAll, reloadCounter });

	useEffect(() => {
		if (onTotalChange && typeof total === 'number' && total >= 0) {
			onTotalChange(total);
		}
	}, [total, onTotalChange]);

	return (
		<>
			<JSONPretty data={listFilterPageSort?.filterModel ?? {}} className="json-wrapper"></JSONPretty>
			<ListComponent
				hideTableToolbar={false}
				onFilterPageSortChange={handleFilterPageSortChange}
				enableSelection={false}
				dataProviderName={dataProviderName}
				items={items}
				total={total}
				totalLabel={t('totalLeadsFounded')}
				customHeader={true}
				loading={loading}
				onRowDoubleClick={() => {}}
				apiRef={apiRef}
				title={t(moduleName)}
				isEmbedded={true}
				headerFilters={false}
				filters={filters}
			/>
		</>
	);
};

export default ListLead;
